import { render, staticRenderFns } from "./StreamerAgent.vue?vue&type=template&id=045f2e60&scoped=true"
import script from "./StreamerAgent.vue?vue&type=script&lang=js"
export * from "./StreamerAgent.vue?vue&type=script&lang=js"
import style0 from "./StreamerAgent.vue?vue&type=style&index=0&id=045f2e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f2e60",
  null
  
)

export default component.exports